import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() { this.apply(document.documentElement.dataset.siteTheme || "light") }

  async change(event) {
    event.preventDefault()
    event.stopPropagation()
    const form = event.target
    const data = new FormData(form)
    const theme = data.get("theme")
    if (!["light", "dark", "black"].includes(theme)) return
    const previous = document.documentElement.dataset.siteTheme || "light"
    this.apply(theme)
    try {
      this.queue = (this.queue || Promise.resolve()).catch(() => {}).then(async () => {
        const response = await fetch(form.action, {
          method: "PATCH", body: data, credentials: "same-origin",
          headers: { Accept: "application/json", "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "" }
        })
        if (!response.ok) throw new Error("Theme could not be saved")
      })
      await this.queue
    } catch {
      if (document.documentElement.dataset.siteTheme === theme) this.apply(previous)
      window.alert("Не удалось сохранить тему. Попробуйте ещё раз.")
    }
  }

  apply(theme) {
    document.documentElement.dataset.siteTheme = theme
    document.documentElement.dataset.bsTheme = theme === "light" ? "light" : "dark"
    document.querySelectorAll('[data-controller~="theme"] form').forEach((form) => {
      form.querySelector("button")?.classList.toggle("active", new FormData(form).get("theme") === theme)
    })
  }
}
